module.exports = __webpack_public_path__ + "img/tel.916162bd.png";